import Tab from "components/Tab/tabModel"
import { useSelector } from "react-redux"
import { getAccessRoles } from "app/redux/authorization/authorization.selectors"
import { arraysIntersect } from "utils"
import { FeatureFlagTypes } from "components/SupportSettingsToggler/types"
import { Roles } from "app/models/user"
import { EmployeeSettingsRoutes } from "app/routes/types"
import * as practiceSelectors from "../../redux/practice/practice.selectors"

export type TabConfig = {
  id: EmployeeSettingsRoutes
  label: JSX.Element
  featureRestriction?: FeatureFlagTypes
  accessRoles?: Roles[]
}

export const useFilterTabsByFeatureFlags = <T extends Tab | TabConfig>(tabs: T[]): T[] => {
  const currentAccessRoles = useSelector(getAccessRoles)
  const features = useSelector(practiceSelectors.getPracticeFeatures)
  return tabs.filter(({ featureRestriction, accessRoles }) => {
    const featureRestricted = featureRestriction ? features?.[featureRestriction] : true
    const hasAccess = accessRoles ? arraysIntersect(accessRoles, currentAccessRoles) : true
    return featureRestricted && hasAccess
  })
}
